/**
 * Created by jonas on 2021-02-09.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {gsap} from "gsap";
import {ISymbol} from "../../../core/reel/ReelInterfaces";
import {TheBorder} from "../../TheBorder";
import {TheBorderStatics} from "../../TheBorderStatics";
import {TheBorderReelView} from "./TheBorderReelView";
import {TheBorderReelModel} from "../../reels/TheBorderReelModel";
import {TheBorderGameMode} from "../../server/TheBorderGameMode";

export class TheBorderAllReelsView extends PIXI.Container implements StageLayer {

    private _mainReelModels:TheBorderReelModel[];

    constructor() {
        super();
    }

    public reInit(){
        for (let i = 0; i < this._mainReelModels.length; i++) {
            const reel = this._mainReelModels[i];
            reel.clear();
            reel.init(TheBorder.model.data.reels[i],false, true);
        }
    }

    public init() {
        this.name = "TheBorderAllReelsView";

        const isAvalancheRestore:boolean = TheBorder.model.isRestore == true && TheBorder.model.data.nextMode == TheBorderGameMode.NORMAL_AVALANCHE
            || TheBorder.model.data.nextMode == TheBorderGameMode.FREESPIN_AVALANCHE || TheBorder.model.data.nextMode == TheBorderGameMode.SUPER_FREESPIN_AVALANCHE;
        const isBonusIntroRestore:boolean = TheBorder.model.isRestore == true && TheBorder.model.data.mode == TheBorderGameMode.NORMAL
            && (TheBorder.model.data.nextMode == TheBorderGameMode.FREESPIN || TheBorder.model.data.nextMode == TheBorderGameMode.SUPER_FREESPIN);
        this._mainReelModels = [];
        let tempReel:string[];

        for(let i:number = 0; i < TheBorderStatics.defaultGameAreaSize.length; i++) {
            tempReel = [];
            const reelModel:TheBorderReelModel = new TheBorderReelModel(i);
            this._mainReelModels.push(reelModel);
            this.addChild(<TheBorderReelView>reelModel.reelView);
            if(isAvalancheRestore == true && isBonusIntroRestore == false) {
                for(let j:number = 0; j < TheBorder.model.initData.reelsAfterCollapse[i].length; j++) {
                    tempReel.push(TheBorder.model.initData.reelsAfterCollapse[i][j]);
                }
            } else if(isBonusIntroRestore == true) {
                for(let j:number = 0; j < TheBorder.model.initData.reelsEnteringFreespin[i].length; j++) {
                    tempReel.push(TheBorder.model.initData.reelsEnteringFreespin[i][j]);
                }
            } else {
                for(let j:number = 0; j < TheBorderStatics.defaultGameAreaSize[i]; j++) {
                    tempReel.push(TheBorder.model.data.reels[i][j]);
                }
            }

            reelModel.init(tempReel, isAvalancheRestore, isBonusIntroRestore);
        }

        const mainReelsMask:PIXI.Graphics = new PIXI.Graphics();
        mainReelsMask.name = "mainReelsMask";
        mainReelsMask.beginFill();
        mainReelsMask.drawRect(0, 0, this.getReelAreaWidth(), (this.getReelAreaHeight()));
        mainReelsMask.position = TheBorderStatics.MAIN_REELS_VIEW_MASK_POSITION;
        this.addChild(mainReelsMask);
        this.mask = mainReelsMask;

        this.position = TheBorderStatics.MAIN_REELS_VIEW_POSITION;
    }

    public hideAllReelsUntilAllIn():void {
        for(let i:number = 0; i < this.mainReelModels.length; i++) {
            this._mainReelModels[i].reelView.hideReelUntilAllIn();
        }
    }


    private getReelAreaHeight():number {
        return TheBorderStatics.symbolHeight * 6;
    }

    private getReelAreaWidth():number {
        return (TheBorderStatics.symbolWidth * 6) + 70; // #164
    }

    public getLandingShake(reverse:boolean, reelId:number, distanceSensitive:boolean = false):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        const target = reverse ? -10 : 10;
        for(let i:number = 0; i < this.mainReelModels.length; i++) {
            const model = this.mainReelModels[i];
            const view = model.reelView;
            let distMultiplier = 1;
            if(distanceSensitive) {
                const distance = Math.abs(i - reelId) + 1;
                distMultiplier = 1 / distance;
            }

            tl.add(gsap.to(view.position, {
                duration : 0.1,
                y : target * distMultiplier,
                ease : TheBorderStatics.reelLandingShake
            }), 0);

        }
        return tl;
    }

    public getAllReels():ISymbol[][] {
        let allReels:ISymbol[][] = [];
        for(let i:number = 0; i < 6; i++) {
            allReels.push(this.mainReelModels[i].reelView.getAllSymbols());
        }
        return allReels;
    }

    public getAllReelsSymbolName():string[][] {
        let allReels:string[][] = [];
        for(let i:number = 0; i < 6; i++) {
            let reel:string[] = [];
            let symbolReel:ISymbol[] = this.mainReelModels[i].reelView.getAllSymbols();
            for(let i = 0; i < symbolReel.length; i++) {
                reel.push(symbolReel[i].symbolName);
            }
            allReels.push(reel);
        }
        return allReels;
    }

    public getSymbolAtPosition(reel:number, position:number):ISymbol {
        return this.mainReelModels[reel].getSymbol(position);
    }

    public getReelLength(reel:number):number {
        return this.mainReelModels[reel].reelView.children.length;
    }

    public getAllVisibleSymbols():ISymbol[] {
        let result:ISymbol[] = [];
        for(let reel of this.mainReelModels) {
            result = result.concat(reel.getAllSymbols());
        }

        return result;
    }

    get mainReelModels():TheBorderReelModel[] {
        return this._mainReelModels;
    }
}
